export type InfoScreenLocationDisplayDirectionType = 0 | 1 | 2 | 3 | 4;

interface IInfoScreenLocationDisplayDirectionTypeEnum {
    None: InfoScreenLocationDisplayDirectionType;
    Top: InfoScreenLocationDisplayDirectionType;
    Right: InfoScreenLocationDisplayDirectionType;
    Down: InfoScreenLocationDisplayDirectionType;
    Left: InfoScreenLocationDisplayDirectionType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
    getType(key: string): InfoScreenLocationDisplayDirectionType;
}

const dataSource = () => [
    { key: 0, text: 'Nerodyti' },
    { key: 1, text: 'Aukštyn' },
    { key: 2, text: 'Dešinė' },
    { key: 3, text: 'Žemyn' },
    { key: 4, text: 'Kairė' }
];

export const infoScreenLocationDisplayDirectionType: IInfoScreenLocationDisplayDirectionTypeEnum = {
    None: 0,
    Top: 1,
    Right: 2,
    Down: 3,
    Left: 4,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    },
    getType(key: string) {
        switch (parseInt(key)) {
            case 0:
                return infoScreenLocationDisplayDirectionType.None;
            case 1:
                return infoScreenLocationDisplayDirectionType.Top;
            case 2:
                return infoScreenLocationDisplayDirectionType.Right;
            case 3:
                return infoScreenLocationDisplayDirectionType.Down;
            case 4:
                return infoScreenLocationDisplayDirectionType.Left;
            default:
                return infoScreenLocationDisplayDirectionType.None;
        }
    }
};
